import { graphql } from '@/gql';

graphql(`
  fragment PartnerFieldConfigFragment on PartnerFieldConfigEntryType {
    field
    label
    placeholder
    required
  }
`);
